/** Fuel price helpers for invoice creation (base price + per-gallon margin). */

export function parseFuelMargin(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

export function effectiveFuelPricePerGallon(basePrice, margin) {
  return (parseFloat(basePrice) || 0) + parseFuelMargin(margin);
}

export function getFuelMarginsFromForm(formData) {
  return {
    diesel: parseFuelMargin(formData?.diesel_fuel_margin),
    def: parseFuelMargin(formData?.def_fuel_margin),
    dyed: parseFuelMargin(formData?.dyed_fuel_margin),
  };
}

/** YYYY-MM-DD key for pricing lookup (scheduled delivery date preferred). */
export function getJobPricingDateKey(job) {
  if (!job) return null;
  const raw = job.scheduled_date || job.completed_at;
  if (!raw) return null;
  const isoPrefix = String(raw).match(/^(\d{4}-\d{2}-\d{2})/);
  if (isoPrefix) return isoPrefix[1];
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Return pricing row with margins added to each fuel unit price. */
export function applyFuelMarginsToPricing(pricing, margins) {
  if (!pricing) return null;
  return {
    ...pricing,
    diesel_price_per_liter: effectiveFuelPricePerGallon(
      pricing.diesel_price_per_liter,
      margins.diesel
    ),
    def_price_per_liter: effectiveFuelPricePerGallon(pricing.def_price_per_liter, margins.def),
    dyed_price_per_liter: effectiveFuelPricePerGallon(
      pricing.dyed_price_per_liter,
      margins.dyed
    ),
  };
}

export function fuelCostFromDeliveredQuantities(
  { dieselQty, defQty, dyedQty },
  billedPricing
) {
  if (!billedPricing) return 0;
  let total = 0;
  if (dieselQty > 0) {
    total += dieselQty * parseFloat(billedPricing.diesel_price_per_liter);
  }
  if (defQty > 0) {
    total += defQty * parseFloat(billedPricing.def_price_per_liter);
  }
  if (dyedQty > 0) {
    total += dyedQty * parseFloat(billedPricing.dyed_price_per_liter);
  }
  return total;
}
